import { tourStep } from './tourRegistry';

export const bandaDocumentosSteps = [
  tourStep(
    'documentos-header',
    'Documentos de la banda',
    'Biblioteca interna (estatutos, seguros, actas…). No es el archivo de partituras. Tú decides qué sale al <strong>tablón público</strong>.',
  ),
  tourStep(
    'documentos-upload',
    'Subir documento',
    'Solo el <strong>titular</strong> de la cuenta puede subir. Pon título y categoría para encontrarlo después.',
  ),
  tourStep(
    'documentos-list',
    'Biblioteca',
    'Abre, filtra o marca «En el tablón». Quien reciba el enlace público solo ve esos archivos, con la misma contraseña.',
    'top',
  ),
  tourStep(
    'documentos-tablon-share',
    'Enlace al tablón',
    'Activa una contraseña para generar el enlace. Compártelo por WhatsApp o cópialo: es la vista pública de los documentos que marques.',
    'top',
  ),
];
